import { useState, useRef, useEffect } from "react";
import { Pencil, Edit, Users, Pin, Trash2 } from "lucide-react";

export default function EditChatMenu() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const menuItems = [
    { icon: <Edit className="w-4 h-4" />, label: "Edit Chat", onClick: () => {} },
    { icon: <Users className="w-4 h-4" />, label: "Create Group", onClick: () => {} },
    { icon: <Pin className="w-4 h-4" />, label: "Pin Chat", onClick: () => {} },
  ];

  return (
    <div className="relative" ref={menuRef}>

      {/* Button */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="p-2 rounded-full hover:bg-white/10 transition-colors"
      >
        <Pencil className="w-5 h-5 text-white/60" />
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute right-0 mt-2 w-48 bg-[#1a1a1a] border
          border-white/10 rounded-2xl shadow-2xl z-50 overflow-hidden
          animate-scaleIn">

          <div className="py-1.5">
            {menuItems.map((item, i) => (
              <button
                key={i}
                onClick={() => { item.onClick(); setOpen(false); }}
                className="flex items-center gap-3 w-full px-4 py-2.5
                  text-white/70 hover:text-white hover:bg-white/5
                  transition-colors text-sm"
              >
                <span className="text-white/40">{item.icon}</span>
                {item.label}
              </button>
            ))}

            {/* Delete — red */}
            <div className="border-t border-white/10 mt-1 pt-1">
              <button
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 w-full px-4 py-2.5
                  text-red-400 hover:bg-red-500/10
                  transition-colors text-sm"
              >
                <Trash2 className="w-4 h-4" />
                Delete Chat
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .animate-scaleIn {
          animation: scaleIn 0.15s cubic-bezier(0.32, 0.72, 0, 1);
        }
        @keyframes scaleIn {
          from { transform: scale(0.95); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
}